/**
 * Utilities for handling Matrix reply message formatting
 */

/**
 * Strips Matrix reply fallback text from message body.
 *
 * Reply fallback format per Matrix spec:
 *   > <@user:server> Original message line 1
 *   > Original message line 2
 *
 *   Actual reply text
 *
 * @param {string} body - The message body
 * @returns {string} - Body with fallback stripped
 */
export const stripReplyFallback = (body) => {
  if (!body || typeof body !== 'string') return body;

  // Matrix reply fallback regex pattern:
  // - First line: > <@user:server> message (or > * <@user:server> for action/emote)
  //   Note: [^\n\r]* allows empty content after user ID (was [^\n\r]+ which required 1+ chars)
  // - Subsequent quoted lines: > continuation
  // - Followed by a blank line
  // - Then the actual reply text
  const fallbackRegex = /^>( \*)? <[^>]+>[^\n\r]*\r?\n(> [^\n]*\r?\n)*\r?\n/;

  return body.replace(fallbackRegex, '');
};
